









































import Vue, { PropType } from 'vue';
import { OutlinedTextInput, AutoCompleteInput } from '@descomplica/vue-components';
import Checkbox from '@/components/Checkbox.vue';

export interface InstitutionOption {
  key: string;
  value: string;
}

export interface TransferGraduationInstitutionInfoFormEvent {
  course?: string;
  periodYear?: string;
  institution?: InstitutionOption;
  hasAcceptedToS: boolean;
}

export default Vue.extend({
  components: { OutlinedTextInput, AutoCompleteInput, Checkbox },
  props: {
    currentCourse: {
      type: String,
      default: '',
    },
    currentPeriodYear: {
      type: String,
      default: '',
    },
    currentInstitution: {
      type: Object as PropType<InstitutionOption>,
      default: () => ({} as any),
    },
    availableInstitutions: {
      type: Array as PropType<InstitutionOption[]>,
      required: true,
    },
    fallbackInstitution: {
      type: Object as PropType<InstitutionOption>,
      default: () => ({} as any),
    },
    userName: {
      type: String,
      required: true,
    },
    tosAccepted: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      course: this.currentCourse,
      periodYear: this.currentPeriodYear,
      institution: this.currentInstitution,
      hasError: false,
      hasAcceptedToS: this.tosAccepted,
      tosLink: process.env.VUE_APP_DESCOMPLICA_TOS_LINK,
    };
  },
  methods: {
    periodYearFormatter(value: string) {
      const matchedValue = value.match(/(\d{1,2})/g);

      return matchedValue ? matchedValue[0] : '';
    },
    inputHandler() {
      const event: TransferGraduationInstitutionInfoFormEvent = {
        course: this.course,
        periodYear: this.periodYear,
        institution: this.institution,
        hasAcceptedToS: this.hasAcceptedToS,
      };
      this.$emit('input', event);
    },
    selectedHandler(selected: InstitutionOption) {
      this.institution = selected;
      this.inputHandler();
    },
    autoCompleteInputHandler(input: string) {
      this.$emit('search', input);
    },
    checkboxChangeHandler(event: any) {
      this.hasAcceptedToS = event.target.checked;
      this.inputHandler();
    },
  },
});
